import React, { Component } from "react";
import { Row } from "antd";
import styled from "styled-components";
import { Typography } from "../../core";

const FIXED_TO = require("../../helper/utils/Fixed");
const LabelContainer = styled.div`
  width: 297mm !important;
  min-height: 210mm !important;
  size: landscape !important;
  @media print {
    width: 297mm !important;
    min-height: 210mm !important;
    size: landscape !important;
  }
`;
const ContainerInner = styled.div`
  height: ${(props) => (props.children.length <= 14 ? "auto" : "284.808mm")};
`;
const StyledTabel = styled.table`
  border: 1px solid darkblue;
  border-spacing: 0;
  clear: both;
  margin: 2mm 0mm;
  /* height: 100mm; */
  width: 100%;

  th,
  td {
    border-left: 1px solid darkblue;
  }
  tr {
    border-bottom: 1px solid darkblue;
    height: 14.5mm;
  }
  th:first-child,
  td:first-child {
    border-left: none;
  }
  th {
    border-bottom: 1px solid darkblue;
  }
  td {
    vertical-align: top;
    font-size: 8pt;
  }
  th {
    text-align: center;

    font-weight: bold;
    font-size: 8pt;
  }
  .amount {
    text-align: right;
  }
`;

class PageGenerator extends Component {
  render() {
    const NumberPages = [];
    const total_quantity = this.props.data
      .map((invoice) => invoice.net_pass_quantity)
      .reduce((acc, curr) => acc + curr, 0);

    const total_exclude_tax = this.props.data
      .map((invoice) => parseFloat(invoice.total_price_without_sale_tax))
      .reduce((acc, curr) => acc + curr, 0);

    const total_tax = this.props.data
      .map((invoice) => parseFloat(invoice.total_sale_tax_payable))
      .reduce((acc, curr) => acc + curr, 0);

    const total_with_tax = this.props.data
      .map((invoice) => parseFloat(invoice.total_value_include_sale_tax))
      .reduce((acc, curr) => acc + curr, 0);

    var newArray = [];
    let countPage = Math.ceil(this.props.data.length / 18);
    for (let value = 0; value <= countPage - 1; value++) {
      let singleArray = [];
      for (let k = value * 18; k <= 18 * (value + 1) - 1; k++) {
        if (this.props.data[k]) {
          singleArray.push(this.props.data[k]);
        } else {
          break;
        }
      }
      newArray.push(singleArray);
    }
    for (let l = 0; l <= newArray.length - 1; l++) {
      let Children = [];
      newArray[l].forEach((item, index) => {
        Children.push(
          <tr key={index} item={item}>
            <td>{index + 1}</td>
            <td>{item.invoice_date}</td>
            <td>{item.invoice_no}</td>
            <td>
              <span>
                {/* {item.invoice_note} */}
                {item.cloth_quality}
                <br />
                HS CODE: {item.hs_code} @ {item.rate_per_meter}
              </span>
            </td>
            <td>{FIXED_TO.round_of_zero(item.net_pass_quantity)}</td>
            <td>{FIXED_TO.round_of_zero(item.total_price_without_sale_tax)}</td>
            <td>{FIXED_TO.round_of_zero(item.total_sale_tax_payable)}</td>
            <td>
              {" "}
              {FIXED_TO.round_of_zero(item.total_value_include_sale_tax)}
            </td>
            <td>
              <span>
                {item.buyer_company_name} {item.address}. NTN: {item.ntn} STRN:{" "}
                {item.strn}
              </span>
            </td>
          </tr>
        );
      });
      NumberPages.push(
        <LabelContainer className="page" Children>
          <div>
            {console.log("his.props.", this.props)}
            <Typography as="h4" noMargin weight="500" align="center">
              REGISTER OF SALE
            </Typography>
            <Typography as="h5" noMargin weight="500" align="center">
              UNDER SECTION 22(1) OF SALES TAX (AMENDMENT) ACT, 1990
            </Typography>
            <Typography as="h6" noMargin weight="500" align="center">
              from {this.props.dateFilter.from} to {this.props.dateFilter.to}
            </Typography>
            <Typography as="span" fontSize="16px">
              Name & Address
            </Typography>
            <Row tyep="flex" justify="space-between">
              <Typography as="span" fontSize="16px" weight="500">
                {this.props.companyDetail.company_name}
              </Typography>
              <Typography as="span" fontSize="16px" weight="500">
                {this.props.companyDetail.company_address}
              </Typography>
              <Typography as="span" fontSize="16px" weight="500">
                NTN:
                {this.props.companyDetail.ntn}
              </Typography>
              <Typography as="span" fontSize="16px" weight="500">
                STRN:
                {this.props.companyDetail.strn}
              </Typography>
            </Row>
          </div>

          <ContainerInner className="subpage">
            <StyledTabel>
              <tr className="invoice_line">
                <th>SR #</th>
                <th>Dated</th>
                <th>Invoice No</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Excel S.Tax</th>
                <th>Sales Tax Amnt</th>
                <th> Value Incl.</th>
                <th>Name of Parties to whom application made</th>
              </tr>
              {Children}
              {countPage === l + 1 ? (
                <tr>
                  <td colspan="4">
                    <Typography as="h4" align="center" weight="bold" noMargin>
                      Total
                    </Typography>
                  </td>
                  <td>
                    <Typography as="h4" align="center" weight="bold" noMargin>
                      {FIXED_TO.round_of_zero(total_quantity)}
                    </Typography>
                  </td>
                  <td>
                    <Typography as="h4" align="center" weight="bold" noMargin>
                      {FIXED_TO.round_of_zero(total_exclude_tax)}
                    </Typography>
                  </td>
                  <td>
                    <Typography as="h4" align="center" weight="bold" noMargin>
                      {FIXED_TO.round_of_zero(total_tax)}
                    </Typography>
                  </td>
                  <td>
                    <Typography as="h4" align="center" weight="bold" noMargin>
                      {FIXED_TO.round_of_zero(total_with_tax)}
                    </Typography>
                  </td>
                  <td></td>
                </tr>
              ) : null}
            </StyledTabel>
          </ContainerInner>
        </LabelContainer>
      );
    }
    console.log(NumberPages);
    return NumberPages;
  }
}
class PreviewReport extends Component {
  render() {
    return (
      <div style={{ width: "100%" }}>
        <PageGenerator
          data={this.props.state.salereport}
          dateFilter={this.props.state.filter}
          companyDetail={this.props.companyDetail}
        />
      </div>
    );
  }
}
export default PreviewReport;
